// Webpack Imports
import * as bootstrap from 'bootstrap';
import $ from 'jQuery';

( function () {
	'use strict';

	// Focus input if Searchform is empty
	[].forEach.call( document.querySelectorAll( '.search-form' ), ( el ) => {
		el.addEventListener( 'submit', function ( e ) {
			var search = el.querySelector( 'input' );
			if ( search.value.length < 1 ) {
				e.preventDefault();
				search.focus();
			}
		} );
	} );

	// Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers
	var popoverTriggerList = [].slice.call( document.querySelectorAll( '[data-bs-toggle="popover"]' ) );
	var popoverList = popoverTriggerList.map( function ( popoverTriggerEl ) {
		return new bootstrap.Popover( popoverTriggerEl, {
			trigger: 'focus',
		} );
	} );

  $('#grade-submit').on('click',function(){
    $('#slip_type').val('grade_slip');
    $('#fca-event-pick-form').addClass('grade_form');
  });

  var picks = '';

  $('.match-finish-button').on('click',function(){
    var parId = $(this).parents('.event-match').attr('id').split('event-match-')[1];
    var newPick = $(this).data('finish-value');
    if( !$(this).parents('.event-match').hasClass('multiple-picks') ){
      $(this).parents('.event-match').find('.match-finish-button.active').removeClass('active');
      $(this).addClass('active');
      $('#match-pick-' + parId).val(newPick);
    } else {
      //multiple picks handling
      var count = $(this).parents('.event-match').data('picks-number');

      if( $(this).hasClass('active') ){
        $(this).removeClass('active');
        return false;
      } else {
        if( $(this).parents('.event-match').find('.match-finish-button.active').length >= count ){
          alert('You have already selected the total picks. Please Unselect one.');
          return false;
        }
        //
        picks = '';
         if( $(this).parents('.event-match').find('.match-finish-button.active').length > 0 ){

           $(this).parents('.event-match').find('.match-finish-button.active').each(function(){
             picks = picks + $(this).data('finish-value') + "|";
           });
           picks = picks + newPick;
         } else {
           picks = newPick;
         }

         $(this).addClass('active');
         console.log(picks);
        $('#match-pick-' + parId).val(picks);
      }
    }
  });

  $('#login-nav,#single-login-button,.match-title-quick-click,.login-nav').on('click',function(){
    $("html, body").animate({ scrollTop: 0 }, "slow");
    if( $('#top-nav-login-row').hasClass('active') ){
      $('#top-nav-login-row').slideUp(400).removeClass('active');
      return false;
    } else {
      $('#top-nav-login-row').slideDown(800).addClass('active');
      return false;
    }
  });

  $('#award-week').on('click',function(){
    var week_start = $(this).data('start-week');
    var week_end = $(this).data('end-week');
    var week = week_start + ' - ' + week_end;
    console.log(week);

    //var goldUser = $('#leaderboard-weekly .card.gold').data('name');
    //var silverUser = $('#leaderboard-weekly .card.silver').data('name');
    //var bronzeUser = $('#leaderboard-weekly .card.bronze').data('name');

    var goldUser = [];
    var silverUser = [];
    var bronzeUser = [];

    $('#leaderboard-weekly .gold').each(function(){
      goldUser.push( $(this).data('name') );
    });
    $('#leaderboard-weekly .silver').each(function(){
      silverUser.push( $(this).data('name') );
    });
    $('#leaderboard-weekly .bronze').each(function(){
      bronzeUser.push( $(this).data('name') );
    });

    var week_data = {
      action : 'submit_award_week',
      week : week,
      gold: goldUser,
      silver: silverUser,
      bronze: bronzeUser
    };

    console.log(week_data);

    $.ajax({
      url : ajax_url,
      type : 'post',
      data : week_data,
      success : function( response ) {
          alert( 'Awarding this week...' );
          $('#award-week').after('<h3>This week has been graded!</h3>');
      },
      fail : function( err ) {
         alert( "There was an error: " + err );
      }
    });
  });

  $('#award-month').on('click',function(){
    var week_start = $(this).data('start-week');
    var week_end = $(this).data('end-week');
    var week = week_start + ' - ' + week_end;
    console.log(week);

    var goldUser = $('#leaderboard-monthly .card.gold').data('name');
    var silverUser = $('#leaderboard-monthly .card.silver').data('name');
    var bronzeUser = $('#leaderboard-monthly .card.bronze').data('name');

    var week_data = {
      action : 'submit_award_month',
      month : week,
      gold: goldUser,
      silver: silverUser,
      bronze: bronzeUser
    };

    console.log(week_data);

    $.ajax({
      url : ajax_url,
      type : 'post',
      data : week_data,
      success : function( response ) {
          alert( 'Awarding this month...' );
          $('#award-month').after('<h3>This month has been graded!</h3>');
      },
      fail : function( err ) {
         alert( "There was an error: " + err );
      }
    });
  });

  $('#award-ppv').on('click',function(){
    var ppv_name = $(this).data('ppv-name');

    var goldUser = [];
    var silverUser = [];
    var bronzeUser = [];

    //var goldUser = $('#event-scores .gold').data('name');
    //var silverUser = $('#event-scores .silver').data('name');
    //var bronzeUser = $('#event-scores .bronze').data('name');

    $('#event-scores .gold').each(function(){
      goldUser.push( $(this).data('name') );
    });
    $('#event-scores .silver').each(function(){
      silverUser.push( $(this).data('name') );
    });
    $('#event-scores .bronze').each(function(){
      bronzeUser.push( $(this).data('name') );
    });

    var week_data = {
      action : 'submit_award_ppv',
      ppv_name : ppv_name,
      gold: goldUser,
      silver: silverUser,
      bronze: bronzeUser
    };

    console.log(week_data);

    $.ajax({
      url : ajax_url,
      type : 'post',
      data : week_data,
      success : function( response ) {
          alert( 'Awarding this PPV...' );
          $('#award-ppv').after('<h3>This PPV has been graded!</h3>');
      },
      fail : function( err ) {
         alert( "There was an error: " + err );
      }
    });

  });

} )();
